module.exports = __webpack_public_path__ + "img/chromatography.dc2f32d9.svg";